import { aramaMetni } from "./katalog";

/** Marka adresi: "Filli Boya" -> "filli-boya", "İzeltaş" -> "izeltas" */
export const markaSlug = (ad) => aramaMetni(ad).replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
export const markaYolu = (ad) => `/marka/${markaSlug(ad)}`;

/**
 * Kısa marka tanıtımları: yalnızca katalogda bulunan ürün gruplarını anlatır.
 * Listede olmayan markalar için sayfa, ürün gruplarından otomatik bir tanıtım üretir.
 */
export const MARKA_TANITIMLARI = {
  dewalt: "Profesyonel akülü ve elektrikli el aletleri: darbeli matkaplar, SDS kırıcı-deliciler, darbeli vidalamalar, taşlamalar, testereler ve zımparalar. 18V XR ve 54V FlexVolt serileri.",
  bosch: "Kesme, delme ve vidalama aksesuarları: SDS ve metal matkap uçları, elmas ve metal kesme diskleri, delik açma testereleri, bits uçlar ve zımparalar.",
  makita: "Matkap ucu, freze ucu, mandren ve kesme aksesuarları.",
  izeltas: "Profesyonel el aletleri: anahtarlar, lokma takımları, tornavidalar, penseler, keskiler, çektirmeler ve takım dolapları. 1000V izoleli seri dahil.",
  dekor: "Boya rulo ve fırçaları, boya aksesuarları, sıvacı aletleri ve temizlik ürünleri.",
  sgs: "El aletleri, mala ve ıspatulalar, matkap uçları ve hırdavat ürünleri.",
  kalekim: "Seramik yapıştırıcıları, derz dolguları, su yalıtımı, zemin uygulamaları ve yapı kimyasalları.",
  "filli-boya": "İç ve dış cephe boyaları, tavan boyaları, astarlar ve dekoratif boyalar.",
  polisan: "İç ve dış cephe boyaları ve astarlar.",
  marshall: "İç ve dış cephe boyaları, astar ve macunlar.",
  viko: "Anahtar ve prizler, grup prizler, çerçeveler, fişler ve sigorta kutuları.",
  eca: "Lavabo ve banyo bataryaları, duş setleri.",
  vitra: "Lavabo ve banyo bataryaları, duş setleri.",
  creavit: "Lavabo ve banyo bataryaları, duş setleri.",
  dalsan: "Yapı alçıları, alçı levhalar, kuru duvar profilleri ve aksesuarları, asma tavan sistemleri ve şap ürünleri.",
  izocam: "Taşyünü, camyünü, XPS ve EPS ısı-ses yalıtım malzemeleri; tesisat yalıtımı.",
  soudal: "Silikonlar, mastikler, poliüretan köpükler, montaj yapıştırıcıları ve tabancalar.",
  selsil: "Silikon, mastik, montaj köpüğü, temizleyiciler ve sprey boya.",
  akfix: "Poliüretan köpük ve hızlı yapıştırıcılar.",
  adocim: "Portland, Portland kalkerli ve puzolanik çimentolar (TS EN 197-1).",
  atlas: "Elektrikli ve akülü el aletleri, jeneratörler, kompresörler, pompalar ve zımparalar.",
  kilsan: "Isı yalıtımlı, akustik ve taşıyıcı tuğlalar.",
  ytong: "Gazbeton bloklar: dolgu ve taşıyıcı duvar, yüksek yalıtımlı seriler.",
  kalde: "Su ve doğalgaz tesisat boruları ve bağlantı parçaları.",
  beybi: "İş eldivenleri: nitril, lateks ve poliüretan kaplı eldivenler.",
  "delta-plus": "Baret, güvenlik gözlüğü, iş ayakkabısı, eldiven ve kulak koruyucular.",
  essafe: "Baret, siperlik, vizör, kaynak maskesi ve kulak koruyucular.",
  "3m": "Toz ve gaz maskeleri, filtreler, kulak koruyucular, baret ve gözlükler.",
  magmaweld: "Örtülü elektrodlar, gazaltı kaynak telleri, kaynak makineleri ve torç parçaları.",
  askaynak: "Örtülü elektrodlar, gazaltı ve tozaltı kaynak telleri, TIG, örtülü elektrod ve plazma makineleri.",
  cata: "LED ampul, panel ve armatürler.",
};
